module.exports = __webpack_public_path__ + "static/media/rock-master.514f130d.png";